module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAsCAYAAAB2d9g5AAAABGdBTUEAALGPC/xhBQAAAP1JREFUWAntmKEOwjAQhv+7IECCWwISzSMMxSMhCSGovcheYzwCGiTJHBpGstIb4pKNoK4To6cuFfe1Xyuan+DruLkuXhUy55ACLpE1u6KSGQXceLsv5jcSWPXE2YOmdpDuJALuRJMVy8lCwwTvgBnokfFHY3dHIVbqGmv2bOM7+7VVl3hgvzV84Kgt9HBa+hdsV7v04h+o1vCVxhPqbRt1UamRSB0TlaoLoy4qNRKpY6JSdWHURaVGInVMVKoujLqo1EikjuldKbX//rqXMF3vJ/wLIJVhbuvbVMlsJLTpqYTFkhBJaBOa2TA8i5s4ShIiphwIoVc0Ui4plLDeu0U3x7ZCcuYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Components/Specialties/img/mobile.png
// module id = 142
// module chunks = 0